export const FASTER_CHECKOUT_TEST_NAME = 'faster-checkout-q3-2023';
export const FASTER_CHECKOUT_CONTROL_NAME = 'fcq3-2023-control';
export const FASTER_CHECKOUT_VARIANT_NAME = 'fcq3-2023-variant';
